<script setup>
  import { computed, ref, onMounted } from 'vue'
  import BcsDynamicText from '../BcsDynamicText.vue'
  import { useTemplateVariablesStore } from '../../stores/TemplateVariablesStore'

  const props = defineProps({
    planStartDate: {
      type: String,
      required: true
    }
  })

  const templateStore = useTemplateVariablesStore()
  const { getDefinitionById } = templateStore

  const confirmRenewalContent = ref('')

  // Format date for display (MM/DD/YYYY to MM/DD/YYYY)
  const formattedPlanStartDate = computed(() => {
    if (!props.planStartDate) return ''
    
    // If already in MM/DD/YYYY format, return as is
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(props.planStartDate)) {
      return props.planStartDate
    }
    
    // Otherwise try to parse and format
    try {
      const date = new Date(props.planStartDate)
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const year = date.getFullYear()
      return `${month}/${day}/${year}`
    } catch (e) {
      return props.planStartDate
    }
  })

  onMounted(async () => {
    const text = await getDefinitionById('confirmRenewalContent', '', '', '', false)
    confirmRenewalContent.value = text.body
  })
</script>

<template>
  <div class="text-center mb-4 px-4">
    <h4 class="header-20 mb-3"><strong>
      <BcsDynamicText :key="confirmRenewalTitle"
        text="confirmRenewalTitle" :variables="{ formattedPlanStartDate }" />
    </strong></h4>
    <div class="px-3" v-html="confirmRenewalContent"></div>
  </div>
</template>
